<template>
    <article>
        <p>
            Coroot uses ClickHouse to store Logs, Traces, and Profiles.
            To integrate Coroot with ClickHouse, go to the project settings (<v-icon small>mdi-cog</v-icon>),
            click on <b>Clickhouse</b>, and define the ClickHouse address and credentials as shown in the following example:
        </p>

        <v-card max-width="1200">
            <v-img eager src="/static/img/docs/coroot/clickhouse_configuration.png" />
        </v-card>

        <p>
            Coroot handles its own schema in ClickHouse, so you don’t need to do anything manually.
        </p>

        <h2>Clustered ClickHouse</h2>

        <p>
            If Coroot is set up to work with a distributed ClickHouse cluster (sharded and/or replicated),
            it automatically detects it using the <var>SHOW CLUSTERS</var> command.
        </p>

        <p>Here’s how Coroot chooses a cluster:</p>

        <ul>
            <li>If no clusters are set up, it creates the table on the connected ClickHouse instance (single-node mode)</li>
            <li>If there’s only one cluster, it uses that</li>
            <li>If there are multiple clusters, it chooses the <var>coroot</var> cluster, or <var>default</var> if <var>coroot</var> isn’t available</li>
        </ul>


        <h2>TTL (Time To Live)</h2>

        <p>
            ClickHouse allows you to set a retention policy for tables when they are created.
            Currently, Coroot uses a hardcoded TTL of 7 days and doesn't yet support changing it through the UI.
            However, you can manually adjust it by running the <a href="https://clickhouse.com/docs/en/sql-reference/statements/alter/ttl" target="_blank"><var>ALTER TABLE ... MODIFY TTL</var></a> query.
        </p>
    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
